import { motion, useAnimation } from "framer-motion";
import React, { useState } from "react";
import { useEffect } from "react";
import { useInView } from "react-intersection-observer";
import Button from "@mui/material/Button";
import "./card.css";
import "../Baner/Banner.css";

const ProjectCard = ({ data, animationTime }) => {
  const [clicked, setClicked] = useState(false);

  const handleClicked = () => {
    setClicked(!clicked);
  };
  const { ref, inView } = useInView();
  const boxAnimation = useAnimation();
  const aboutAnimation = useAnimation();
  const animation = useAnimation();

  useEffect(() => {
    if (inView) {
      boxAnimation.start({
        y: 0,
        transition: {
          duration: 0.2,
        },
        opacity: 1,
      });
    } else {
      boxAnimation.start({
        y: 250,
        opacity: 0,
      });
    }
  }, [inView]);

  return (
    <div className="px-4 my-5 lg:my-9">
      <motion.div
        ref={ref}
        animate={boxAnimation}
       
        className="relative w-full lg:w-96 flex flex-col justify-center items-center  bg-[#000000] bg-opacity-50 rounded-lg shadow-md shadow-blue-600 group transition-all duration-1000 hover:scale-105 z-30 space-y-5 pb-5 
        h-[36rem]"
      >
        <div className="z-20 h-full w-full relative ">
          <img
            className=" h-full w-full rounded-t-lg"
            src={data.imgUrl}
            alt={data.projectName}
          />
          {/* <div className="absolute h-5 z-10 fadout">

          </div> */}
        </div>

        <div className="flex flex-col items-center justify-center pt-1 z-10 bottom-5 delay-700 px-5 space-y-5">
          <p className={`text-gray-200 text-2xl font-bold `}>
            {data.projectName}
          </p>
          <p className={`text-gray-400 text-center`}>{data.about}</p>
          <div className={`flex flex-wrap  justify-center space-x-2`}>
            {data.tech.map((item) => {
              return (
                <p
                  className="px-2 py-1 my-1 border border-blue-800 rounded-full text-white text-sm font-thin"
                  key={item}
                  size="small"
                  variant="outlined"
                >
                  {item}
                </p>
              );
            })}
          </div>
        </div>

        <div className={` space-x-5`}>
          <Button variant="outlined">
            {" "}
            <a href={data.codeUrl} target="-blanck">
              Source Code
            </a>
          </Button>
          <Button variant="outlined">
            <a href={data.websiteUrl} target="-blank" rel="noopener noreferrer">
              Website
            </a>
          </Button>
        </div>
      </motion.div>
    </div>
  );
};

export default ProjectCard;
